import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const SocialProofSection = () => {
  const [currentStat, setCurrentStat] = useState(0);
  const [animatedStats, setAnimatedStats] = useState({
    students: 0,
    jobPlacement: 0,
    avgSalary: 0,
    companies: 0
  });

  const stats = [
    {
      id: 7,
      value: 500000,
      label: "Learning Hours Delivered",
      icon: "Building2",
      color: "text-cyber-purple",
      suffix: "+"
    },
    {
      id: 1,
      value: 10000,
      label: "Students Mentored",
      icon: "Users",
      color: "text-accent",
      suffix: "+"
    },
    {
      id: 4,
      value: 5000,
      label: "Projects Completed",
      icon: "Building2",
      color: "text-cyber-purple",
      suffix: "+"
    },
    {
      id: 5,
      value: 500,
      label: "Workshops Conducted",
      icon: "Building2",
      color: "text-cyber-purple",
      suffix: "+"
    },
    {
      id: 2,
      value: 100,
      label: "Competition Prize Wins",
      icon: "TrendingUp",
      color: "text-success",
      suffix: "+"
    },
    {
      id: 3,
      value: 10,
      label: "Research Papers Published",
      icon: "DollarSign",
      color: "text-warning",
      suffix: "+"
    },
    {
      id: 6,
      value: 10,
      label: "Partner Institutions",
      icon: "Building2",
      color: "text-cyber-purple",
      suffix: "+"
    },
    {
      id: 8,
      value: 5,
      label: "Startups & Ventures Founded by Alumni",
      icon: "Building2",
      color: "text-cyber-purple",
      suffix: "+"
    }
  ];

  // const partnerCompanies = [
  //   {
  //     name: "Google",
  //     logo: "https://images.unsplash.com/photo-1573804633927-bfcbcd909acd?w=120&h=60&fit=crop",
  //     category: "Tech Giant"
  //   },
  //   {
  //     name: "Microsoft",
  //     logo: "https://images.unsplash.com/photo-1633419461186-7d40a38105ec?w=120&h=60&fit=crop",
  //     category: "Cloud Services"
  //   },
  //   {
  //     name: "Tesla",
  //     logo: "https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=120&h=60&fit=crop",
  //     category: "Automotive AI"
  //   },
  //   {
  //     name: "Amazon",
  //     logo: "https://images.unsplash.com/photo-1523474253046-8cd2748b5fd2?w=120&h=60&fit=crop",
  //     category: "E-commerce"
  //   },
  //   {
  //     name: "Meta",
  //     logo: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=120&h=60&fit=crop",
  //     category: "Social Media"
  //   },
  //   {
  //     name: "Apple",
  //     logo: "https://images.unsplash.com/photo-1621768216002-5ac171876625?w=120&h=60&fit=crop",
  //     category: "Consumer Tech"
  //   }
  // ];

  // const testimonials = [
  //   {
  //     id: 1,
  //     name: "Sarah Johnson",
  //     role: "AI Engineer at Google",
  //     avatar: "https://images.unsplash.com/photo-1494790108755-2616b9c3c8e4?w=64&h=64&fit=crop&crop=face",
  //     content: "DCC transformed my career completely. The hands-on projects and mentorship helped me land my dream job at Google within 6 months of graduation.",
  //     rating: 5,
  //     company: "Google",
  //     salary: "$165,000"
  //   },
  //   {
  //     id: 2,
  //     name: "Marcus Rodriguez",
  //     role: "Robotics Engineer at Tesla",
  //     avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=64&h=64&fit=crop&crop=face",
  //     content: "The robotics program at DCC is unmatched. Real hardware, real projects, real results. Now I'm working on autonomous vehicles at Tesla!",
  //     rating: 5,
  //     company: "Tesla",
  //     salary: "$145,000"
  //   },
  //   {
  //     id: 3,
  //     name: "Priya Patel",
  //     role: "ML Engineer at Microsoft",
  //     avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=64&h=64&fit=crop&crop=face",
  //     content: "From zero coding experience to Microsoft in 8 months. The community support and structured learning path made all the difference.",
  //     rating: 5,
  //     company: "Microsoft",
  //     salary: "$140,000"
  //   }
  // ];

  // const certifications = [
  //   {
  //     name: "ISO 27001 Certified",
  //     icon: "Shield",
  //     description: "Information Security Management"
  //   },
  //   {
  //     name: "SOC 2 Type II",
  //     icon: "Lock",
  //     description: "Security & Availability"
  //   },
  //   {
  //     name: "GDPR Compliant",
  //     icon: "CheckCircle",
  //     description: "Data Protection Standards"
  //   },
  //   {
  //     name: "AWS Education Partner",
  //     icon: "Award",
  //     description: "Cloud Training Excellence"
  //   }
  // ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStat((prev) => (prev + 1) % stats.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const animateStats = () => {
      stats.forEach((stat, index) => {
        const duration = 2000;
        const steps = 60;
        const increment = stat.value / steps;
        let current = 0;

        const timer = setInterval(() => {
          current += increment;
          if (current >= stat.value) {
            current = stat.value;
            clearInterval(timer);
          }

          setAnimatedStats(prev => ({
            ...prev,
            [stat.label.toLowerCase().replace(/\s+/g, '')]: Math.floor(current)
          }));
        }, duration / steps);
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          animateStats();
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    const element = document.getElementById('stats-section');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  const formatStatValue = (stat, value) => {
    if (stat.format === 'currency') {
      return `${stat.prefix || ''}${(value / 1000).toFixed(0)}K${stat.suffix || ''}`;
    }
    return `${stat.prefix || ''}${value.toLocaleString()}${stat.suffix || ''}`;
  };

  return (
    <section className="py-20 bg-card/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Stats Section */}
        <div id="stats-section" className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
              Proven <span className="gradient-text">Results</span>
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Join thousands of successful graduates who have transformed their careers through our community-driven approach.
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {stats.map((stat, index) => (
              <div
                key={stat.id}
                className={`holographic-card p-6 text-center transition-all duration-500 ${
                  index === currentStat ? 'shadow-glow-strong scale-105' : ''
                }`}
              >
                <div className={`w-12 h-12 rounded-full bg-muted/30 flex items-center justify-center mx-auto mb-4 ${stat.color}`}>
                  <Icon name={stat.icon} size={24} />
                </div>
                <div className="text-2xl sm:text-3xl font-bold text-foreground mb-2">
                  {formatStatValue(stat, animatedStats[stat.label.toLowerCase().replace(/\s+/g, '')] || 0)}
                </div>
                <div className="text-sm text-muted-foreground">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Partner Companies */}
        {/* <div className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-2xl font-bold text-foreground mb-4">
              Trusted by Industry Leaders
            </h3>
            <p className="text-muted-foreground">
              Our graduates work at the world's most innovative companies
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {partnerCompanies.map((company, index) => (
              <div
                key={index}
                className="holographic-card p-4 flex flex-col items-center justify-center hover:shadow-glow transition-all duration-300"
              >
                <Image
                  src={company.logo}
                  alt={company.name}
                  className="w-16 h-8 object-contain mb-2 opacity-70 hover:opacity-100 transition-opacity duration-300"
                />
                <div className="text-xs text-muted-foreground text-center">{company.category}</div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Testimonials */}
        {/* <div className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-2xl font-bold text-foreground mb-4">
              Success Stories
            </h3>
            <p className="text-muted-foreground">
              Hear from our graduates who are now leading innovation at top companies
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="holographic-card p-6">
                <div className="flex items-center space-x-3 mb-4">
                  <Image
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full"
                  />
                  <div>
                    <div className="font-semibold text-foreground">{testimonial.name}</div>
                    <div className="text-sm text-accent">{testimonial.role}</div>
                  </div>
                </div>

                <div className="flex items-center space-x-1 mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Icon key={i} name="Star" size={14} className="text-warning fill-current" />
                  ))}
                </div>

                <blockquote className="text-sm text-muted-foreground mb-4 italic">
                  "{testimonial.content}"
                </blockquote>

                <div className="flex items-center justify-between text-xs">
                  <span className="text-muted-foreground">{testimonial.company}</span>
                  <span className="text-success font-medium">{testimonial.salary}</span>
                </div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Certifications */}
        {/* <div>
          <div className="text-center mb-12">
            <h3 className="text-2xl font-bold text-foreground mb-4">
              Security & Compliance
            </h3>
            <p className="text-muted-foreground">
              Your data and learning experience are protected by industry-leading standards
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {certifications.map((cert, index) => (
              <div key={index} className="holographic-card p-6 text-center">
                <div className="w-12 h-12 rounded-full bg-success/20 flex items-center justify-center mx-auto mb-4">
                  <Icon name={cert.icon} size={24} className="text-success" />
                </div>
                <div className="font-semibold text-foreground mb-2">{cert.name}</div>
                <div className="text-xs text-muted-foreground">{cert.description}</div>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default SocialProofSection;